import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-otp',
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <input
      [id]="id"
      maxlength="1"
      type="text"
      [formControl]="control"
      (keyup)="onKeyUp($event)"
      [ngClass]="{
        'border-red-500': control.invalid && control.touched
      }"
      class="p-3 rounded-lg border w-full border-[#CED4DA] focus:outline-none text-center"
    />
  `
})
export class OtpComponent {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() control!: FormControl;

  onKeyUp(event: any) {
    if (event.key === 'Backspace') {
      // @ts-ignore
      document.getElementById(Number(this.id) - 1)?.children[0].focus();
    } else {
      // @ts-ignore
      document.getElementById(Number(this.id) + 1)?.children[0].focus();
    }
  }
}
